import React, { useEffect, useRef, useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

export default function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const containerRef = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      <div
        style={{
          padding: '40px',
          color: '#F3E5AB',
          fontFamily: 'Milonga, serif',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <h1 style={{ fontSize: '48px', marginBottom: '0px' }}>About Me</h1>
      </div>

      <div
        style={{
          padding: isMobile ? '20px' : '100px',
          color: '#F3E5AB',
          fontFamily: 'Milonga, serif',
          fontSize: isMobile ? '18px' : '24px',
          textAlign: 'left',
          maxWidth: '1000px',
          margin: '0 auto',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr',
            gap: '20px',
            alignItems: 'start',
          }}
        >
          <div>
            <p>My name is Elijah Garmon, also known as AgentWebFoot. I graduated in May 2025 with a bachelor’s degree in computer science from Florida Polytechnic University, where I focused on artificial intelligence and software engineering. I am currently a graduate student at the University of Central Florida, working towards my Masters in Computer Science. I’m passionate about building user-centered, real-world solutions that have a meaningful impact.</p>
          
            <p>
            From fall of 2024 to spring of 2025, I have been worked with the Polk County Sheriff’s Office as the Project Manager to design a new application for their officers known as Predictive Policing. We developed software to host an interactive map that would take in data from ongoing database of police reports to locate high crime areas dependent on the time of day and even search for possible patterns between different crimes. Through this process, we got to work closely with Polk County Deputies and to design a new and improved website to host this program and assist their law enforcement officers.
            </p>
          </div>

          <div>
            <img
              src="/images/Elijah.JPG"
              alt="Elijah"
              style={{
                maxWidth: '200px',
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
                marginBottom: '20px',
              }}
            />
            
            <img
              src="/images/floridapoly.png"
              alt="Florida Poly"
              style={{
                maxWidth: '200px',
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
              }}
            />
          </div>
        </div>

        <div style={{ marginTop: '40px' }}>
          <p>
            During the summer of 2024, I took part in an internship with the Senior Resource Alliance of Florida, a nonprofit focused on connecting senior adults with other government and nonprofit resources. While there, I developed an artificial intelligence chat bot that could help improve response time within their call center by searching and logging resources from their database. This task was challenging as I was in charge of spearheading the project as the sole contributor. 
          </p>

          <p>
            Outside of work, I enjoy creative and collaborative hobbies. I’m a former French horn player and lifelong lover of music. I’m also an avid tabletop gamer: I am the Dungeon Master for a weekly Dungeons & Dragons campaign that has been ongoing for 8 years, and play other TTRPGs such as Lancer, Mage the Awakening, and Pathfinder 2e. Additionally, I play Warhammer 40K and spend a lot of time painting miniatures and building my Necron and Ork armies, participating in many Crusades .
          </p>
        </div>
      </div>
    </div>
  );
}
